import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATUS,
} from 'services/api';
import {
  AdvancedSearchItem,
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';
import { combineReducers } from 'redux';

import { RepresentativesActionTypes } from './actions';

import { transformRepresentative } from '../transformations';

const initialState = {
  _status: INITIAL_API_STATUS,
  items: [],
};

/**
 * Transforms search item received from server to our format
 * @param response
 */
export const transformSearch = (serverSearchItem: any): AdvancedSearchItem => {
  return {
    id: serverSearchItem.id,
    columns: serverSearchItem.columns,
    searchName: serverSearchItem.searchName,
    isDefault: serverSearchItem.isDefault,
  };
};

const fetchRepresentativesReducer = createApiReducer(
  [
    RepresentativesActionTypes.FETCH_REPRESENTATIVES_START,
    RepresentativesActionTypes.FETCH_REPRESENTATIVES_SUCCESS,
    RepresentativesActionTypes.FETCH_REPRESENTATIVES_FAILURE,
  ],
  (data) => ({ items: data.results.map(transformRepresentative) }),
  (data) => data
);

const fetchSearchReducer = createFetchSearchReducer('representative');
const addSearchReducer = createAddSearchReducer('representative');
const updateSearchReducer = createUpdateSearchReducer('representative');
const deleteSearchReducer = createDeleteSearchReducer('representative');

const representativeChainedReducers = chainReducers(
  initialState,
  fetchRepresentativesReducer
);

const searchChainedReducers = chainReducers(
  initialState,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  representatives: representativeChainedReducers,
  searches: searchChainedReducers,
});
